<!--
 * @Author: Lsuihua Lsuihua_email@163.com
 * @Date: 2023-11-21 09:40:41
 * @LastEditors: Lsuihua Lsuihua_email@163.com
 * @LastEditTime: 2023-12-25 15:05:47
 * @FilePath: \internation-live-web\src\views\home\index.vue
 * @Description: 首页
-->
<template>
  <div class="kj-live">
    <header class="kj-live-header">
      <section class="live-header-top row-between-center content-row">
        <div class="row-start-center">
          <div class="logo row-start-center">
            <img
              style="height: 100%"
              src="//kjoss.fjdaze.com/kjLive/images/web_imgs/logo.png"
            />
            <span class="ml-10">店长直播</span>
          </div>
          <div
            v-for="nav in navList"
            :key="nav.key"
            :data-key="nav.key"
            :class="['px-18 nav-item', activeKey === nav.key ? 'active' : '']"
          >
            {{ nav.label }}
          </div>
          <el-button round @click="dialogVisible = true" class="ml-10">
            <el-icon class="mr-4 c-numberBlue f-16"><BellFilled /></el-icon>
            调价通知</el-button
          >
        </div>
        <el-button type="primary" round @click="toLogin" size="large"
          >进入导播台</el-button
        >
      </section>
    </header>
    <div class="video-content">
      <div class="box">
        <div class="text">
          <div>
            <img
              class="w400 al-log"
              src="//kjoss.fjdaze.com/kjLive/images/web_imgs/alibaba-logo.png"
              alt=""
            />
            <div class="title fw-700 my-30">
              经营国际站时，您是不是有以下的困惑!
            </div>
          </div>

          <ol class="text-content">
            <li class="text-item acitve">
              <div class="hd fw-800 mt-60">没时间,也没团队</div>
              <!-- <p class="lH32 desc">
                流量都在凌晨以后的时区，而你没办法7×24小时运转。有些电商平台的流量高峰时段可能集中在凌晨以后，这是因为不同地区的用户使用习惯不同。然而，如果你无法全天候运营，就无法抓住这些流量高峰时段。这可能会导致错失一些销售机会，因为用户可能在你休息的时候进行购物。为了解决这个问题，可以考虑雇佣客服人员或合作伙伴来帮助你全天候运营。
              </p> -->
            </li>
            <li class="text-item">
              <div class="hd fw-800 mt-60">不会外语,也不专业</div>
              <!-- <p class="lH32 desc">
                想直播时，却不会外语，也没有专业直播设备和团队。直播已经成为一种非常流行的营销方式，可以吸引更多的用户关注和购买产品。然而，如果你不懂外语，就无法与海外用户进行有效的沟通和互动。此外，直播需要专业的设备和团队来支持，包括摄像设备、音频设备、灯光等。如果没有这些资源，直播的效果可能会受到影响。
              </p> -->
            </li>
            <li class="text-item">
              <div class="hd fw-800 mt-60">开了店,发了品,没流量?</div>
              <!-- <p class="lH32 desc">
                错过平台红利期，只发品效果不好没有流量。在电商平台上，每个平台都会有一个红利期，也就是平台的推广和用户增长阶段。如果错过了这个阶段，只依靠发布产品来获取流量的效果可能会比较差。因为在红利期，平台会给予更多的曝光和推荐机会，而在红利期过后，竞争会更加激烈，需要更加努力才能获得流量。
              </p> -->
            </li>
          </ol>
        </div>
      </div>
      <video
        id="video"
        class="w-auto"
        loop
        muted
        autoplay
        src="//kjoss.fjdaze.com/kjLive/images/web_imgs/video.mp4?id=2"
      ></video>
    </div>
    <section id="wayLive" class="way-live pageKey pt-30">
      <div class="content-row">
        <h2 class="hd">为什么要做直播？</h2>
        <div class="row-start-center content t-left">
          <div class="text-desc">
            <p class="f-20 lH-42">
              在初始阶段，国际站的发展已进入一个关键时期。其初期的红利期，即第一波流量获取的机会，已经被头部企业所抢占。如今，国际站的搜索流量大部分已被这些企业瓜分完毕，中小企业想要从中分一杯羹，无疑面临着巨大的挑战。在这种情况下，直播流量成为了新的竞争赛道。
            </p>
            <div class="mt-52 c-white">
              <el-button
                :icon="Clock"
                color="#1E6AFF"
                size="large"
                round
                type="primary"
                >抢流量</el-button
              >
              <el-button
                :icon="Flag"
                color="#FF7A19"
                class="c-white"
                size="large"
                round
                type="warning"
                >占新赛道</el-button
              >
            </div>
          </div>
          <img
            class="pic"
            src="//kjoss.fjdaze.com/kjLive/images/web_imgs/way-do.png"
          />
        </div>
      </div>
    </section>

    <section id="liveToDo" class="live-to-do pageKey">
      <div class="content-row pt-30 pb-70 c-white">
        <h2 class="hd">
          <span>店长直播</span><span class="c-warn">能做什么</span>
        </h2>
        <div class="content mt-12">
          <div
            v-for="(todo, ind) in todoList"
            :key="ind"
            class="t-center todo-item"
          >
            <el-image :src="todo.img" class="w-auto"></el-image>
            <div class="pt-10 pb-40 pt-32">
              <div class="c-title c-title f-20 fw-700 mb-12">
                {{ todo.title }}
              </div>
              <p class="c-dec">{{ todo.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="livePk" class="content-row pageKey py-30">
      <h2 class="hd">
        <span>店长直播的</span><span class="c-warn">优势</span>
        <img
          class="w-auto"
          src="//kjoss.fjdaze.com/kjLive/images/web_imgs/live-pk.png"
        />
      </h2>
    </section>

    <section id="funDetail" class="fun-detail pageKey pt-30 pb-80">
      <div class="content-row">
        <h2 class="hd">
          <span>店长直播</span><span class="c-warn">功能细节</span>
        </h2>
        <div class="content mt-12">
          <div
            v-for="(func, ind) in funcDetails"
            :key="ind"
            class="t-center func-item"
          >
            <el-image :src="func.img" class="w-auto"></el-image>
            <div class="pt-10 pb-20 relative">
              <h3 class="c-title">{{ func.title }}</h3>
              <ul class="c-dec func-list mt-40 pl-40 pr-20">
                <li v-for="(funItem, ind) in func.funcs" :key="ind">
                  {{ funItem }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- <section id="softwarePrice" class="software-vip pageKey pt-30 pb-80">
      <div class="content-row">
        <h2 class="hd">
          <span>成为店长</span><span class="c-warn">直播会员</span>
        </h2>
        <div class="content mt-12">
          <div
            v-for="(software, ind) in softwarePriceList"
            :key="ind"
            class="t-center software-item relative"
          >
            <el-image :src="`${software.img}?id=2`"></el-image>
            <div class="price" v-if="packageList">
              <div>
                <span class="f-24 mr-6">&yen;</span>
                <span>{{ packageList[ind].price }}</span>
              </div>
              <el-button
                :class="['buyBtn', 'v-' + software.key]"
                size="large"
                round
                @click="toLogin"
                >立即购买</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <footer
      id="contactUs"
      class="contact-us pageKey t-left pt-50 pb-30 c-white"
    >
      <div class="content-row">
        <div class="row-start-center">
          <el-image
            class="logo mr-10"
            src="//kjoss.fjdaze.com/kjLive/images/web_imgs/logo.png"
          ></el-image>
          <span class="f-30"
            >店长直播，助力商家打破传统直播，占领新的竞争赛道</span
          >
        </div>
        <el-divider style="width: 770px; opacity: 0.2" />
        <div>
          <ul class="footer-nav">
            <li>
              <div class="c-999 mb-26 f-16">其他产品</div>
              <a
                class="row-start-center c-white"
                href="https://kj.fjdaze.com"
                target="_blank"
              >
                <img
                  src="//kjoss.fjdaze.com/projectImages/logo-blue.png"
                  class="mr-10 w34"
                />
                <span class="f-24">大泽店长工具</span>
              </a>
            </li>
            <li>
              <div class="c-999 mb-26 f-16">联系我们</div>
              <ul class="f-14 c-999 contac" style="list-style: none">
                <li class="row-start-center">
                  <el-icon :size="20"> <Phone /> </el-icon>
                  <span class="ml-4">电话：400-0591-321</span>
                </li>
                <li class="row-start-start">
                  <el-icon :size="20"> <LocationFilled /> </el-icon>
                  <span class="ml-4"
                    >总部：福建·福州市高新区科技东路10号 中青科研中心
                    中青大厦12层1202</span
                  >
                </li>
                <li class="row-start-start">
                  <el-icon :size="20"> <Clock /> </el-icon>
                  <span class="ml-4">上班时间：周一至周五 9:00-21:00</span>
                </li>
              </ul>
            </li>
            <li>
              <img
                class="w120"
                src="//kjoss.fjdaze.com/projectImages/web/ewm.png"
              />
            </li>
          </ul>
        </div>
        <el-divider style="opacity: 0.2" />
        <div class="t-center c-999">
          &copy;2015-2022福建大泽网络科技有限公司 版权所有 闽ICP备15016648号-1
          增值电信业务经营许可证：闽B2-20180149 闽公网安备 35010202000243号
        </div>
      </div>
    </footer>
  </div>
  <login ref="loginRef" @sign="toSign" />
  <Sign ref="signRef" @login="toLogin" />
  <el-dialog v-model="dialogVisible" width="440">
    <el-image
      src="//kjoss.fjdaze.com/kjLive/images/web_imgs/priceNotice.jpg"
      :preview-src-list="[
        '//kjoss.fjdaze.com/kjLive/images/web_imgs/priceNotice.jpg',
      ]"
    ></el-image>
  </el-dialog>
</template>

<script>
import { ref, defineAsyncComponent, onMounted } from "vue";
import { Clock, Flag, Phone, LocationFilled } from "@element-plus/icons-vue";
// import axios from "@/common/axios";
export default {
  name: "home-index",
  components: {
    login: defineAsyncComponent(() => import("@/components/Login.vue")),
    Sign: defineAsyncComponent(() => import("@/components/Sign.vue")),
  },
  setup() {
    onMounted(() => {
      let navList = Array.from(document.querySelectorAll("header .nav-item"));
      let pageKeyNavs = Array.from(document.querySelectorAll(".pageKey"));

      for (let key in navList) {
        let item = navList[key];
        item.addEventListener("click", (e) => {
          if (activeKey.value === e.target.dataset.key) {
            return;
          }
          let targetRow = pageKeyNavs.find((p) => {
            return p.id === e.target.dataset.key;
          });
          if (targetRow) {
            activeKey.value = e.target.dataset.key;
            return window.scrollTo({
              top: targetRow.offsetTop - window.innerHeight / 3,
              behavior: "smooth",
            });
          }
        });
      }

      // 监听滚动切换高亮
      ListenerScroll(pageKeyNavs);

      // getPackages();
      voideTextAnimate();
    });
    const loginRef = ref(null);
    const signRef = ref(null);

    const activeKey = ref(null);
    const packageList = ref(null);
    const dialogVisible = ref(false);
    const navList = ref([
      {
        label: "为什么要做直播",
        key: "wayLive",
      },
      {
        label: "店长直播做什么呢？",
        key: "liveToDo",
      },
      {
        label: "店长直播VS传统直播",
        key: "livePk",
      },
      {
        label: "功能细节",
        key: "funDetail",
      },
      // {
      //   label: "软件定价",
      //   key: "softwarePrice",
      // },
      {
        label: "联系我们",
        key: "contactUs",
      },
    ]);

    const todoList = ref([
      {
        title: "快速开播",
        desc: "简单4个步骤就能开播",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/todo-1.jpg",
      },
      {
        title: "实时接待",
        desc: "自动语音文字回复",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/todo-2.jpg",
      },
      {
        title: "支持多语言",
        desc: "多语种，覆盖全球客户",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/todo-3.jpg",
      },
      {
        title: "直播不违规",
        desc: "符合阿里国际站直播规则",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/todo-4.jpg",
      },
    ]);

    const funcDetails = ref([
      {
        title: "AI一键生成",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/func-1.jpg",
        funcs: [
          "支持100多语言",
          "AI文字转语音",
          "AI脚本生成",
          "语音、语速个性化定制",
        ],
      },
      {
        title: "实时自动接待",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/func-2.jpg",
        funcs: [
          "自动文字回复",
          "自动语音回复",
          "视频直播实时推流",
          "自动接待",
          "自动发送名牌你",
          "7×24h全天候直播",
        ],
      },
      {
        title: "简单好上手",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/func-3.jpg",
        funcs: ["简单好上手", "接待监看在一个界面稿定"],
      },
    ]);

    const softwarePriceList = ref([
      {
        key: "quarter",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/v-quarter.png",
      },
      {
        key: "halfYear",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/v-halfYear.png",
      },
      {
        key: "annual",
        img: "//kjoss.fjdaze.com/kjLive/images/web_imgs/v-annual.png",
      },
    ]);

    const toLogin = () => {
      loginRef.value.show();
    };
    const toSign = () => {
      signRef.value.show();
    };

    const ListenerScroll = (pageKeyNavs) => {
      window.addEventListener("scroll", () => {
        let scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        for (let key in pageKeyNavs) {
          let item = pageKeyNavs[key];
          let difHeight = item.offsetTop - scrollTop;
          // 到底直接显示最后一个
          if (
            document.body.scrollHeight - window.scrollY ===
            window.innerHeight
          ) {
            return (activeKey.value = pageKeyNavs[pageKeyNavs.length - 1].id);
          } else if (difHeight < window.innerHeight / 2 && difHeight >= 0) {
            // 滚动切换
            activeKey.value = item.id;
            return;
          } else if (
            // 没有出现
            !pageKeyNavs.find(
              (v) => v.offsetTop - scrollTop <= window.innerHeight / 2
            )
          ) {
            return (activeKey.value = "");
          }
        }
      });
    };

    // const getPackages = () => {
    //   axios.post("/master/package/getPackages").then((res) => {
    //     if (res) {
    //       packageList.value = res.result;
    //     }
    //   });
    // };

    const voideTextAnimate = () => {
      // 文字动画
      const textList = Array.from(
        document.querySelectorAll(".video-content .text-item")
      );
      const textTarget = document.querySelector(".video-content .text-content");

      let timer = setInterval(() => {
        let activeIndex = textList.findIndex((v) =>
          v.className.includes("acitve")
        );
        textList[activeIndex].className = "text-item";
        activeIndex = activeIndex === textList.length - 1 ? 0 : activeIndex + 1;
        textList[activeIndex].className = "text-item acitve";
      }, 5000);

      textTarget.addEventListener("mouseenter", () => {
        clearInterval(timer);
        timer = null;
      });
      textTarget.addEventListener("mouseleave", () => {
        voideTextAnimate();
      });
    };

    return {
      loginRef,
      signRef,
      navList,
      todoList,
      funcDetails,
      softwarePriceList,
      activeKey,
      packageList,
      toLogin,
      toSign,
      Clock,
      Flag,
      Phone,
      LocationFilled,
      voideTextAnimate,
      dialogVisible,
    };
  },
};
</script>

<style lang="scss" scope>
$navHeight: 80px;
$manWidth: 1200px;
$mainColor: #1f65ff;

.kj-live {
  min-width: $manWidth;
}
.content-row {
  width: $manWidth;
  margin: 0 auto;
  .hd {
    font-size: 60px;
  }
}
header.kj-live-header {
  position: sticky;
  top: 0;
  z-index: 9;
  height: $navHeight;
  &::after {
    left: 0;
    top: 0;
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0.7),
      rgba(255, 255, 255, 0.5)
    );
    backdrop-filter: blur(10px);
  }
  .live-header-top {
    height: $navHeight;
    line-height: $navHeight;
    position: relative;
    z-index: 10;
  }
  .logo {
    height: 34px;
    margin-right: 32px;
    color: $mainColor;
    font-weight: 800;
    font-size: 26px;
  }
  .nav-item {
    cursor: pointer;
    position: relative;
    transition: all 0.2s ease-in-out;
  }
  .nav-item.active,
  .nav-item:hover {
    color: $mainColor;
    font-weight: 700;
    &::after {
      content: "";
      width: 15%;
      height: 4px;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      position: absolute;
      background-color: $mainColor;
    }
  }
}
.video-content {
  height: calc(100vh - $navHeight);
  max-height: 800px;
  overflow: hidden;
  position: relative;
  .box {
    position: absolute;
    z-index: 3;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    backdrop-filter: blur(10px);
    color: #fff;
  }
  .text {
    width: 100%;
    margin: auto;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
    text-align: center;
    .title {
      font-size: 52px;
    }
    ol {
      list-style: none;
      position: relative;
      width: 60%;
      height: 294px;
      margin: auto;
      li {
        position: absolute;
        width: 100%;
        line-height: 36px;
        font-size: 18px;
        opacity: 0;
        z-index: -1;
        transform-origin: 100% 100%;
        p {
          margin-top: 90px;
        }
      }
      $animateTime: 5s;
      li.acitve {
        position: absolute;
        font-size: 18px;
        z-index: 3;

        animation: videoTextAnimate $animateTime ease-in infinite;
        animation-play-state: running;
      }
      li.acitve:hover {
        animation-play-state: paused;
      }
      .hd {
        font-size: 106px;
      }
    }
  }
}

.way-live {
  background-color: #f9fbfe;
  overflow: hidden;
  .content {
    display: grid;
    grid-template-columns: 55% 45%;
    grid-column-gap: 134px;
    .el-button--large.is-round {
      padding: 30px 36px;
      font-size: 24px;
      border-radius: 38px;
      &:hover {
        color: #fff;
      }
    }

    .text-desc {
      transform: translateY(-44px);
    }
    .pic {
      transform: translateY(14px);
    }
  }
}

.live-to-do {
  background-image: url("//kjoss.fjdaze.com/kjLive/images/web_imgs/todo-bg.jpg");
  background-size: cover;
  .content {
    display: grid;
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    grid-column-gap: 24px;
    .todo-item {
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
    }
  }
}
.fun-detail {
  background-color: #f2f7ff;
  .content {
    display: grid;
    grid-template-columns: repeat(3, minmax(320px, 1fr));
    grid-column-gap: 24px;
    .func-item {
      background-color: #fff;
      border-radius: 12px;
      overflow: hidden;
      .c-title {
        background-color: $mainColor;
        color: #fff;
        padding: 8px 26px;
        border-radius: 22px;
        font-size: 20px;
        margin: 0;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .func-list {
        display: grid;
        grid-template-columns: repeat(2, minmax(160px, 1fr));
        text-align: left;
        grid-gap: 12px;
      }
    }
  }
}

.software-vip {
  background-color: #f9fbfe;
  .content {
    display: grid;
    grid-template-columns: repeat(3, minmax(320px, 1fr));
    grid-column-gap: 24px;

    .el-button {
      color: #fff;
      outline-width: 0;
    }
    $vColors: (
      quarter: #457bff,
      halfYear: #efbc35,
      annual: #3c2f26,
    );

    @each $key, $value in $vColors {
      .v-#{$key} {
        background-color: $value;
        border-color: lighten($value, 20%);
        &:hover {
          background-color: lighten($value, 10%);
          border-color: lighten($value, 30%);
        }
      }
    }
    .v-halfYear {
      color: #373636;
    }
    .price {
      position: absolute;
      top: 140px;
      left: 50%;
      color: #000;
      font-weight: bold;
      font-size: 52px;
      transform: translateX(-50%);
    }
    .buyBtn {
      font-family: "DIN-Bold";
      padding: 0 32px;
      transform: scale(1.1);
    }
  }
}

.contact-us {
  background-color: #383839;
  .footer-nav {
    list-style: none;
    display: grid;
    grid-template-columns: 30% minmax(30%, 1fr) 120px;
    grid-column-gap: 10px;
    .contac {
      display: grid;
      grid-template-columns: 40% 1fr;
      grid-gap: 12px;
    }
  }
}

@media screen and (max-width: 1366px) {
  .content-row {
    padding: 0 20px;
    box-sizing: border-box;
  }
  .text {
    ol {
      height: 254px !important;
    }
    .al-log {
      width: 300px;
    }
    .title {
      font-size: 42px !important;
    }
    .hd {
      font-size: 86px !important;
      margin-top: 50px;
    }
    .desc {
      margin-top: 60px !important;
    }
  }
}
@media screen and (max-width: 1680px) {
  .video-content {
    .text ol {
      width: 80%;
    }
  }
}

@keyframes videoTextAnimate {
  0% {
    opacity: 0;
    transform: rotate3d(1, 0, 0, -180deg);
  }
  10% {
    opacity: 1;
    transform: rotate3d(1, 0, 0, 0deg);
  }
  90% {
    opacity: 1;
    transform: rotate3d(1, 0, 0, 0deg);
  }
  100% {
    transform: rotate3d(1, 0, 0, 180deg);
    opacity: 0;
  }
}
</style>
